const defaultRender = (value) => (value ? value : "--");

const statusFilter = [
  { text: "Paid", value: "paid" },
  { text: "Unpaid", value: "unpaid" },
  // { text: "Rejected", value: "rejected" },
];

const columns = [
  {
    title: "Client",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "File Name",
    dataIndex: "file",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "File Number",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: defaultRender,
  },
  {
    title: "Payment Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "statusText",
    render: defaultRender,
    filters: statusFilter,
    // onFilter: (value, record) => {
    //   if (value === "rejected")
    //     return record?.status === "unpaid" && record?.reason;
    //   return record?.status === value && !record?.reason;
    // },
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

export default columns;
